import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import AppBar from 'material-ui/AppBar';
import { Link } from 'react-router-dom';
import Tabs, { Tab } from 'material-ui/Tabs';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';
import PrcInput from '../../../components/Form/Input';
import AutoCompleteInput from '../../../components/Form/AutoCompleteInput';
import BookTile from '../../../components/BookTile';
import Notification from '../../../components/Notification';
import Button from '../../../components/Buttons';
import debounce from 'lodash/debounce';
import { searchFetch } from '../../../helper/BookApi';
import './Readings.css';

import PdfContent, {savePdf} from '../../../components/PdfContent';

export default class Readings extends Component {
    static propTypes = {
        watchList: PropTypes.array.isRequired,
        readList: PropTypes.array.isRequired,
        personalBookList: PropTypes.array.isRequired,
        addToWatchList: PropTypes.func.isRequired,
        removeFromWatchList: PropTypes.func.isRequired,
        addToReadList: PropTypes.func.isRequired,
        removeFromReadList: PropTypes.func.isRequired,
        addPersonalBook: PropTypes.func.isRequired,
        isHighGrade: PropTypes.bool.isRequired,
        levelName: PropTypes.string.isRequired,
        levelImage: PropTypes.string.isRequired,
        tabValue: PropTypes.number.isRequired,
    };

    state={
        tabValue: this.props.tabValue,
        prcBook: '',
        prcBookInputValue: '',
        personalBookTitle: '',
        personalBookAuthor: '',
        suggestions:[],
    }

    handleChange = (event, tabValue) => {
        this.setState({ tabValue });
    };

    handleSearchFieldChange = (name) => (event) => {
        this.setState({ [name]: event.target.value });
        if(name === 'personalBookAuthor') {
            this.setState({
                isAuthorFieldError: false,
            });
        }
        if(name === 'personalBookTitle') {
            this.setState({
                isTitleFieldError: false,
            });
        }
    }

    renderBookTiles = () => {
        const correctTab = this.state.tabValue === 0 ? 'watchList' : 'readList';
        return this.props[correctTab].map( (book, i) => {
            return  <BookTile
                key={i}
                book={book}
                isInWatchList={this.state.tabValue === 0}
                isInReadList={this.state.tabValue === 1}
                addToWatchList={this.props.addToWatchList}
                removeFromWatchList={this.props.removeFromWatchList}
                addToReadList={this.addToReadListHandler}
                removeFromReadList={this.props.removeFromReadList}
            />
        })
    }

    addToReadListHandler = (book) =>
        this.props.addToReadList(book)

    addPersonalBookHandler = (event) => {
        if (event) event.preventDefault();

        const {
            personalBookTitle,
            personalBookAuthor,
        } = this.state;

        if(!this.state.personalBookTitle || !this.state.personalBookAuthor) {
            if (!this.state.personalBookTitle) {
                this.setState({
                    isTitleFieldError: true
                })
            }
            if (!this.state.personalBookAuthor) {
                this.setState({
                    isAuthorFieldError: true
                })
            }
            return
        }

        const pcbId = `pcbId${Date.now().toString().slice(-6)}`;
        const personalBookInfo = {
            bookId: pcbId,
            author: personalBookAuthor,
            title: personalBookTitle,
            annotations: 'This is a Personal Choice Book',
            grade: '',
            genre: '',
            series: '',
            isHighGradeBook: false,
            isOfficial: false,
        }
        this.props.addPersonalBook(personalBookInfo)
        this.setState({
            personalBookTitle: '',
            personalBookAuthor: ''
        });
    }

    handlePrcInputChange = (value) => {
        this.setState({ prcBookInputValue: value })
    }

    fetchBookSuggestions = debounce((value) => {
        const inputValue = value.trim().toLowerCase();
        const listNum = 20;
        searchFetch(inputValue, listNum).then((r) => {
            this.setState({
                suggestions: r.length > listNum? r.slice(0, listNum) : r,
            });
        })
    }, 700)

    getSuggestionValue = (prcBook) => {
        this.setState({ prcBook, })
        return `${prcBook.title} (${prcBook.book_id})`
    }

    renderSuggestionOptions = (suggestion) => {
        return (
            <MenuItem component="div" className="autoComplete__list">
                <div className="autoComplete__list--content">
                    <p>{suggestion.title} ({suggestion.book_id})</p>
                    <p className="autoComplete__list--author">by {suggestion.author}</p>
                </div>
            </MenuItem>
        )
    }

    addPrcBookHandler = (event) => {
        if (event) event.preventDefault();

        if(this.state.prcBookInputValue && this.state.prcBook) {
            this.addToReadListHandler(this.state.prcBook)
            this.setState({
                prcBookInputValue:'',
                prcBook: ''
            })
        }
    }

    isDisableAddPersonalBook = (type) => {
        const isEmptyInputs = !this.state.personalBookTitle && !this.state.personalBookAuthor;
        const isComplete = this.props.readList.length >= (this.props.isHighGrade? 20 : 30);
        return type === 'button'? (isComplete || isEmptyInputs) : isComplete
    }

    renderAddBookForm = () => {
        const {
            prcBookInputValue,
            personalBookTitle,
            personalBookAuthor,
            suggestions,
        } = this.state;
        return  <div className="readings__forms">
            <Grid container
                  spacing={24}>
                <Grid item
                      md={4}
                      xs={12}
                      sm={6}>
                    <div>
                        <div className="readings__forms--label">
                            <p tabIndex="0">Add a PRC book</p>
                        </div>
                        <form className="readings__forms--row" onSubmit={this.addPrcBookHandler}>
                            <AutoCompleteInput
                                inputValue={prcBookInputValue}
                                handleInputChange={this.handlePrcInputChange}
                                inputPlaceHolder="Search a PRC Book"
                                getSuggestions={this.fetchBookSuggestions}
                                suggestions={suggestions}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestionOptions}
                            />
                            <Button
                                type="submit"
                                aria-label="add a prc book"
                                variant="flat"
                                className="readings__form--button"
                                color="inherit"
                                disabled={!prcBookInputValue}>
                                Add
                            </Button>
                        </form>
                    </div>
                </Grid>
                <Grid item
                      md={4}
                      xs={12}
                      sm={6}>
                    <div>
                        <div className="readings__forms--label">
                            <p>Add a Personal Choice book (Added {this.props.personalBookList.length} of 10 max)</p>
                        </div>
                        <form className="readings__forms--row" onSubmit={this.addPersonalBookHandler}>
                            <PrcInput
                                id="Readings_Book_Title"
                                label="Peronal book title"
                                className="readings__form--control readings__form--personalBook readings__pcb--title"
                                helpText="This field is required"
                                InputProps={{
                                    disableUnderline: !this.state.isTitleFieldError,
                                    error: this.state.isTitleFieldError,
                                    value: personalBookTitle,
                                    onChange: this.handleSearchFieldChange('personalBookTitle'),
                                    placeholder: "Book Title",
                                    disabled: this.isDisableAddPersonalBook()
                                }}
                            />
                            <PrcInput
                                id="Readings_Book_Author"
                                label="Peronal book author"
                                className="readings__form--control readings__form--personalBook readings__pcb--author"
                                helpText="This field is required"
                                InputProps={{
                                    disableUnderline: !this.state.isAuthorFieldError,
                                    error: this.state.isAuthorFieldError,
                                    value: personalBookAuthor,
                                    onChange: this.handleSearchFieldChange('personalBookAuthor'),
                                    placeholder: "Book Author",
                                    disabled: this.isDisableAddPersonalBook()
                                }}
                            />
                            <Button
                                type="submit"
                                aria-label="add a personal choice book"
                                className="readings__form--button readings__addPrb--button"
                                variant="flat"
                                color="inherit"
                                disabled={this.isDisableAddPersonalBook('button')}>
                                Add
                            </Button>
                        </form>
                    </div>
                </Grid>
            </Grid>
        </div>
    }

    renderReadingLog = () => {
        if(this.state.tabValue === 1 && this.props.readList.length === 0){
            return  <p className="readings__log--emptyMessage">
                You can quick-add PRC or Personal Choice books by using the boxes above!
            </p>
        } else if (this.state.tabValue === 0 && this.props.watchList.length === 0) {
            return  <div className="readings__plan--emptyMessage">
                <p>Save books you like</p>
                <p>Download and print it to pick books from your library !</p>
            </div>
        } else {
            return this.renderBookTiles()
        }
    }

    renderResultsInfo = () => {
        const isWatchListEmpty = this.props.watchList.length === 0;
        const isReadingPlanTab = this.state.tabValue === 0;
        //hide the Button and re-style the Link when on reading plan tab and watch list is empty
        const isDiffButtonLink =  isReadingPlanTab && isWatchListEmpty;
        return  <div className={isDiffButtonLink ?
            "results--info--empty results--info" : "results--info"}>
            {isReadingPlanTab ? //only render link on reading log tab
                <Link to="/">Discover Books to read</Link> : <div></div>}
            {isDiffButtonLink ?
                '' : <Button variant="raised" size="small" color="primary" onClick={() => this.download()}>Download</Button> }
        </div>
    }

    renderBookList = () => {
        return  <div className="readings__results">
            {this.renderResultsInfo()}
            <div>
                <Grid
                    container
                    spacing={24}>
                    {this.renderReadingLog()}
                </Grid>
            </div>
            <div className="hidden">
                <PdfContent {...this.props} {...this.state} />
            </div>
        </div>
    }
    myFunction() {
        return window.open("/prc/srr/personal.html");
    }
    renderReadingHistory  = () => {
        return  <div className="readings__results">

            <div>
                <span>
                Please <a href="/prc/srr/personal.html">click here </a> to access your challenge information from previous years. </span>
            </div>
        </div>
    }


    tab0  = () => {
        return  <div className="readings__results">
            {this.renderBookList()}
        </div>
    }
    tab1  = () => {
        return  <div className="readings__results">
            {this.renderAddBookForm()}
            {this.renderBookList()}
        </div>
    }
    tab2  = () => {
        return  <div className="readings__results">

            {this.renderReadingHistory()}
        </div>
    }



    download = () => {
        const filename = this.state.tabValue === 0 ? 'SavedBooks.pdf' : 'ReadingLog.pdf';
        const label = this.state.tabValue === 0 ? 'Saved Books' : 'Personal Reading Log';
        savePdf(filename, label);
    }

    render () {
        const {
            tabValue,
        } = this.state;
        const {
            watchList,
            readList,
            personalBookList,
            isHighGrade,
            levelName,
            levelImage
        } = this.props;
        return (
            <div className="readings__tabs">
                <Paper>
                    <AppBar position="static" color="default">
                        <Tabs
                            indicatorColor="primary"
                            textColor="primary"
                            value={tabValue}
                            onChange={this.handleChange}
                            fullWidth >
                            <Tab className="readings__tabs--headerButton"
                                 disableRipple
                                 label={
                                     <span>Saved Books ({watchList.length})</span>
                                 }/>
                            <Tab className="readings__tabs--headerButton"
                                 disableRipple
                                 label={
                                     <span>My Reading Log</span>
                                 }/>
                            <Tab className="readings__tabs--headerButton"
                                 disableRipple
                                 label={
                                     <span>
                                         Challenge History
                                    </span>
                                 }/>
                        </Tabs>
                    </AppBar>
                </Paper>
                <Notification
                    readBooksNum={readList.length}
                    personalBookNum={personalBookList.length}
                    markedBooksNum={watchList.length}
                    isHighGrade={isHighGrade}
                    levelName={levelName}
                    levelImage={levelImage}
                />
                {tabValue === 0? this.tab0() : ''}
                {tabValue === 1? this.tab1() : ''}
                {tabValue === 2? this.tab2(): ''}
            </div>
        );
    }
}
